import { render, staticRenderFns } from "./lastName.vue?vue&type=template&id=394f5e34&"
import script from "./lastName.vue?vue&type=script&lang=ts&"
export * from "./lastName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports